import { makeStyles } from '@material-ui/styles';
import { forwardRef } from 'react';
import { UserIcon } from '@bizzabo/design-system';

import { UserPreview } from '@bizzabo/entities';

type UserIconProps = Pick<React.ComponentProps<typeof UserIcon>, 'size'>;

interface UserIconButtonProps {
    user: UserPreview;
    userIconSize?: UserIconProps['size'];
    onClick?: () => void;
}

const UserIconButton = forwardRef<HTMLButtonElement, UserIconButtonProps>(
    ({ user, userIconSize, onClick }, ref) => {
        const classes = useStyles();

        return (
            <button ref={ref} onClick={onClick} className={classes.btn}>
                <UserIcon size={userIconSize} photoUrl={user.photoUrl} />
            </button>
        );
    }
);

const useStyles = makeStyles(
    {
        btn: {
            padding: 0,
            border: 'none',
            cursor: 'pointer',
            background: 'none',
        },
    },
    { classNamePrefix: UserIconButton.name }
);

UserIconButton.displayName = 'UserIconButton';

export default UserIconButton;
